/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommissionCandidateRoleDto } from '../models';
// @ts-ignore
import type { CommissionCandidatesResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
/**
 * CommissionCandidatesApi - axios parameter creator
 * @export
 */
export const CommissionCandidatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns commission candidates for a given certification + commission role:   * users with permission `certification.management.write` (always eligible),   * supervisors of stage-3 (EXAM) participants in the relations configured for the slot in the     exam stage config (P1 / P2 / HRBP; without a config: CHAIRMAN → P2, HRBP → HRBP),   * people on the stage\'s extra commission members list for the slot (`extraMember = true`). 
         * @summary List candidates for commission membership (chairman/HRBP)
         * @param {number} certificationId Certification whose stage-3 participants drive the access-based pool.
         * @param {CommissionCandidateRoleDto} role Which commission role this picker is for (decides which access types are eligible).
         * @param {string} [search] Free-text search across first name, last name, email and SAP number.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommissionCandidates: async (certificationId: number, role: CommissionCandidateRoleDto, search?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('listCommissionCandidates', 'certificationId', certificationId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('listCommissionCandidates', 'role', role)
            const localVarPath = `/api/v2/certifications/commission-candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (certificationId !== undefined) {
                localVarQueryParameter['certificationId'] = certificationId;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommissionCandidatesApi - functional programming interface
 * @export
 */
export const CommissionCandidatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommissionCandidatesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns commission candidates for a given certification + commission role:   * users with permission `certification.management.write` (always eligible),   * supervisors of stage-3 (EXAM) participants in the relations configured for the slot in the     exam stage config (P1 / P2 / HRBP; without a config: CHAIRMAN → P2, HRBP → HRBP),   * people on the stage\'s extra commission members list for the slot (`extraMember = true`). 
         * @summary List candidates for commission membership (chairman/HRBP)
         * @param {number} certificationId Certification whose stage-3 participants drive the access-based pool.
         * @param {CommissionCandidateRoleDto} role Which commission role this picker is for (decides which access types are eligible).
         * @param {string} [search] Free-text search across first name, last name, email and SAP number.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCommissionCandidates(certificationId: number, role: CommissionCandidateRoleDto, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommissionCandidatesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCommissionCandidates(certificationId, role, search, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommissionCandidatesApi.listCommissionCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommissionCandidatesApi - factory interface
 * @export
 */
export const CommissionCandidatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommissionCandidatesApiFp(configuration)
    return {
        /**
         * Returns commission candidates for a given certification + commission role:   * users with permission `certification.management.write` (always eligible),   * supervisors of stage-3 (EXAM) participants in the relations configured for the slot in the     exam stage config (P1 / P2 / HRBP; without a config: CHAIRMAN → P2, HRBP → HRBP),   * people on the stage\'s extra commission members list for the slot (`extraMember = true`). 
         * @summary List candidates for commission membership (chairman/HRBP)
         * @param {number} certificationId Certification whose stage-3 participants drive the access-based pool.
         * @param {CommissionCandidateRoleDto} role Which commission role this picker is for (decides which access types are eligible).
         * @param {string} [search] Free-text search across first name, last name, email and SAP number.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommissionCandidates(certificationId: number, role: CommissionCandidateRoleDto, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<CommissionCandidatesResponseDto> {
            return localVarFp.listCommissionCandidates(certificationId, role, search, page, size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommissionCandidatesApi - interface
 * @export
 * @interface CommissionCandidatesApi
 */
export interface CommissionCandidatesApiInterface {
    /**
     * Returns commission candidates for a given certification + commission role:   * users with permission `certification.management.write` (always eligible),   * supervisors of stage-3 (EXAM) participants in the relations configured for the slot in the     exam stage config (P1 / P2 / HRBP; without a config: CHAIRMAN → P2, HRBP → HRBP),   * people on the stage\'s extra commission members list for the slot (`extraMember = true`). 
     * @summary List candidates for commission membership (chairman/HRBP)
     * @param {number} certificationId Certification whose stage-3 participants drive the access-based pool.
     * @param {CommissionCandidateRoleDto} role Which commission role this picker is for (decides which access types are eligible).
     * @param {string} [search] Free-text search across first name, last name, email and SAP number.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionCandidatesApiInterface
     */
    listCommissionCandidates(certificationId: number, role: CommissionCandidateRoleDto, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<CommissionCandidatesResponseDto>;

}

/**
 * CommissionCandidatesApi - object-oriented interface
 * @export
 * @class CommissionCandidatesApi
 * @extends {BaseAPI}
 */
export class CommissionCandidatesApi extends BaseAPI implements CommissionCandidatesApiInterface {
    /**
     * Returns commission candidates for a given certification + commission role:   * users with permission `certification.management.write` (always eligible),   * supervisors of stage-3 (EXAM) participants in the relations configured for the slot in the     exam stage config (P1 / P2 / HRBP; without a config: CHAIRMAN → P2, HRBP → HRBP),   * people on the stage\'s extra commission members list for the slot (`extraMember = true`). 
     * @summary List candidates for commission membership (chairman/HRBP)
     * @param {number} certificationId Certification whose stage-3 participants drive the access-based pool.
     * @param {CommissionCandidateRoleDto} role Which commission role this picker is for (decides which access types are eligible).
     * @param {string} [search] Free-text search across first name, last name, email and SAP number.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionCandidatesApi
     */
    public listCommissionCandidates(certificationId: number, role: CommissionCandidateRoleDto, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return CommissionCandidatesApiFp(this.configuration).listCommissionCandidates(certificationId, role, search, page, size, options).then((request) => request(this.axios, this.basePath));
    }
}

